import React, { useState, useEffect } from 'react';
import { Send, Trash2 } from 'lucide-react';
import api from '../services/api';
import '../styles/AdminComponents.css';

function ScheduledMessages() {
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const res = await api.get('/conversations');
      const all = [];
      for (const c of res.data) {
        try {
          const s = await api.get(`/scheduled-messages/conversation/${c.id}`);
          s.data.forEach(x => all.push({ ...x, contact_name: c.contact_name, contact_number: c.contact_number }));
        } catch (e) {}
      }
      setItems(all.sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at)));
    } catch (e) {}
  };

  useEffect(() => { load(); }, []);

  const cancel = async (id) => {
    if (!window.confirm('Cancelar envio?')) return;
    await api.delete(`/scheduled-messages/${id}`);
    load();
  };

  return (
    <div className="admin-page">
      <h2><Send size={22}/> Mensagens Agendadas</h2>
      <table className="admin-table">
        <thead>
          <tr><th>Contato</th><th>Envio em</th><th>Mensagem</th><th>Status</th><th></th></tr>
        </thead>
        <tbody>
          {items.map(i => (
            <tr key={i.id}>
              <td>{i.contact_name} ({i.contact_number})</td>
              <td>{new Date(i.scheduled_at).toLocaleString()}</td>
              <td>{i.message_text}</td>
              <td><span className={`badge ${i.status}`}>{i.status}</span></td>
              <td>{i.status === 'pending' && (
                <button onClick={() => cancel(i.id)} className="btn-danger"><Trash2 size={14}/></button>
              )}</td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={5}>Nenhuma mensagem agendada</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export default ScheduledMessages;
